import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, forwardRef, useColorMode, } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
export const TimelineConnector = forwardRef(({ size, ...props }, ref) => {
    const { colorMode } = useColorMode();
    return (_jsx(Flex, { ref: ref, flex: 1, flexBasis: size, opacity: 0.1, borderColor: theme.colors[colorMode].border[4], borderStyle: "solid", borderWidth: theme.sizes['0.5'], ...props }));
});
